import { render } from "./MovimentoDetail.vue?vue&type=template&id=543f8a92&scoped=true"
import script from "./MovimentoDetail.vue?vue&type=script&lang=js"
export * from "./MovimentoDetail.vue?vue&type=script&lang=js"

import "./MovimentoDetail.vue?vue&type=style&index=0&id=543f8a92&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543f8a92"]])

export default __exports__